import React from 'react';
import cn from 'classnames';
import Help from '../Help';

import { CircledCheckIcon } from '@components/Icons';
import Action from '@components/Button/Action';
import Header from '@components/Modals/Header';
import Image from '@components/Image';
import styles from './ContactsAccess.module.scss';

const bubbles = '/img/messages/chat-bubbles.png';
const bubblesLight = '/img/messages/chat-bubbles-light.png';

export default function ContactsAccess({
  hasContactsAccess,
  next,
  prev,
  checkContactsAccess,
  hasDiskAccess,
  setupIntegration,
  forceDarkMode,
}) {
  const [active, setActive] = React.useState(false);

  function contactsAccess() {
    if (hasContactsAccess && hasDiskAccess) {
      setupIntegration();
      next();
      return;
    } else if (hasContactsAccess && !hasDiskAccess) {
      next();
      return;
    }

    setActive(true);
    window.desktopIntegrations.integration.authorize('apple-contacts').then(() => {
      setActive(false);
      checkContactsAccess();
    });
  }

  return (
    <>
      <Header prev={prev}>Contacts access</Header>
      <div className="modal-content">
        <Image
          className={styles.image}
          dark={bubbles}
          light={forceDarkMode ? bubbles : bubblesLight}
          width="200px"
        />
        <p>Clay uses the name from your contacts when it can't find a name otherwise.</p>
        <p>
          <a
            className="text-default"
            href="https://clay.earth/security-and-privacy"
            target="_blank"
          >
            Learn more
          </a>{' '}
          about how contacts data is used.
        </p>
        <p>
          Contacts data remains private to you, and is only used to show names for your contacts.
        </p>

        <Action
          block
          disabled={active}
          onClick={contactsAccess}
          className={cn('btn', hasContactsAccess && styles.contacts)}
          type="button"
          forceDarkMode={forceDarkMode}
        >
          {hasContactsAccess ? (
            <>
              <CircledCheckIcon customColor="#ffffff" className={styles.icon} />
              Continue
            </>
          ) : (
            <>Allow access</>
          )}
        </Action>
        <Help forceDarkMode={forceDarkMode} />
      </div>
    </>
  );
}
